import React, {useState,useEffect,useContext} from "react";
import { useForm } from 'react-hook-form';
import { useNavigate  } from 'react-router-dom';
import Context from '../context/context';
import Lang from '../lang/translations';
import Auth from '../../userServices/authServices';
import helpers from "../_helpers/helpersFunction";
import CryptoJS from "react-native-crypto-js";
import queryString from 'query-string';

const config = require("../_helpers/configServizi"); 



export default function PasswordReset(props) {
	
	 

	const [errore, setErrore] = useState("");

	const [spinner, setSpinner] = useState(false);
	const [password, setPassword] = useState(Lang( {"w": "password","page": "passwordReset","var":true} ));
	const [ripetiPassword, setRipetiPassword] = useState(Lang( {"w": "ripeti","page": "passwordReset","var":true} ));

	const [token, setToken] = useState();
	const [email, setEmail] = useState();
	const [passwordChanged, setPasswordChanged] = useState(false);


	let navigate = useNavigate();
	const context = useContext(Context);

	const domain = window.location.hostname;
  
  const url_logo = config.servizi[domain].logo_su_chiaro;

	const onSubmit = (event) => {
		event.preventDefault(); 

			if(event.target.elements.password.value != event.target.elements.ripetiPassword.value){
				setErrore(Lang( {"w": "non_corrispondono","page": "passwordReset"} ));
				return false;
			}

			const data = {
				token:token,
				email:email,
				password:event.target.elements.password.value,
				servizio: window.location.hostname,
			}
			
			setSpinner(true);
			setErrore("");
			Auth.resetPassword(data)
			.then(res => {
				if(res.result == "OK"){
					setSpinner(false);
					helpers.GetNavigation(res.user.clickid);
					setPasswordChanged(true);
					return true;
					
				}else{
					setErrore(Lang( {"w": "token_expired","page": "passwordReset"} ));
					setSpinner(false);
				}
				
			})
	};

	

	
	
	
	function Spinner(){
		if(spinner){
			return (<div className="spinner-border text-light" role="status">
		 	 <span className="sr-only"><Lang w={"caricando"} page={"passwordReset"}/></span>
		</div>);
		}else{
			return false;
		}
	}
	
	
	useEffect(() => {
		const query = queryString.parse(window.location.search);
		var encrypted = query.token;
		if(encrypted){
			encrypted = window.atob(encrypted)
			let bytes  = CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
			let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)); 
			setToken(decryptedData.token);
			setEmail(decryptedData.email)
		}else{
			context.setModalShowHook(true)
			navigate('/find');
		}
	},[]); 
	
    return (
		<div className="all-container bg-light signuppage">
			<div className="container filters-no-padding form_profilepage" role="main">
				<img src={url_logo} className="logo_recupera_password" />
					<div className="md-12">
						
						{!passwordChanged &&
							<div>
							<h3><Lang w={"procedura"} page={"passwordReset"}/></h3>
							<form className={"formSignup "} onSubmit={(e) => onSubmit(e)}>
								<input type="password" name="password"  placeholder={password} required ></input>
								<input type="password" name="ripetiPassword"  placeholder={ripetiPassword} required></input>
								<p className={errore && 'activeError'}>{errore}</p>
								<input type="submit" value={Lang( {"w": "invia","page": "passwordReset","var":true} )} disabled={spinner}></input>
								<Spinner/>
							</form>
							</div>
						}
						{passwordChanged &&
							<div>
								<h3><Lang w={"passwordCambiata"} page={"passwordReset"}/></h3>
								<h4><a className="navbar-brand" href="/">Homepage</a></h4>
							</div>
						}
					</div>
			</div>
		</div>
	);
}